var _a, _b, _c, _d, _e, _f, _g;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/NotificationEnums';
import { swalAlertError } from '@/core/helpers/sweet-alert';
import ApiService from '@/core/services/ApiService';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_SHARED_GENERAL}`;
const API_URLS = {
    get: `${API_URL}/api/menunotification`,
    read: `${API_URL}/api/markasreadnotification`
};
let NotificationModule = class NotificationModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.NotificationList = [];
        this.NotificationSummary = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1,
            loading: false,
            showingData: 'No data entries'
        };
    }
    // *GETTERS
    get getNotificationList() {
        return this.NotificationList;
    }
    get getNotificationSummary() {
        return this.NotificationSummary;
    }
    get getNotificationLoading() {
        return this.loading;
    }
    get getNotificationPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_NOTIFICATION](data) {
        this.NotificationList = data;
    }
    [_b = Mutations.SET_NOTIFICATION_SUMMARY](data) {
        this.NotificationSummary = data;
    }
    [_c = Mutations.SET_NOTIFICATION_LOADING](data) {
        this.loading = data;
    }
    [_d = Mutations.SET_NOTIFICATION_PAGINATION_LOADING](data) {
        this.pagination.loading = data;
    }
    [_e = Mutations.SET_NOTIFICATION_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize),
            loading: false,
            showingData: data.showingData
        };
    }
    // *start: ACTION
    [_f = Actions.GET_NOTIFICATION](payload) {
        const params = { ver: 'v1' };
        const summaryPayload = {
            userId: payload.data.userId,
            dateFrom: payload.data.dateFrom,
            dateTo: payload.data.dateTo,
            feature: null,
            search: '',
            isAllNotif: 0
        };
        const formdata = payload.isSummary ? summaryPayload : payload.data;
        if (payload.isSummary) {
            this.context.commit(Mutations.SET_NOTIFICATION_SUMMARY, []);
        }
        else {
            this.context.commit(Mutations.SET_NOTIFICATION, []);
            this.context.commit(Mutations.SET_NOTIFICATION_LOADING, true);
            this.context.commit(Mutations.SET_NOTIFICATION_PAGINATION_LOADING, true);
        }
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.get}?${new URLSearchParams(params).toString()}`, formdata)
                .then((response) => {
                const content = response.data.result.content;
                if (payload.isSummary) {
                    this.context.commit(Mutations.SET_NOTIFICATION_SUMMARY, content);
                }
                else {
                    this.context.commit(Mutations.SET_NOTIFICATION, content);
                    this.context.commit(Mutations.SET_NOTIFICATION_PAGINATION, {
                        currentPage: payload.data.pageNo,
                        pageSize: payload.data.pageSize,
                        totalItems: content.length > 0 ? content[0].dataCount : 0,
                        showingData: content.length > 0 ? content[0].showingData : 'No data entries'
                    });
                }
                resolve(content);
            })
                .catch((_response) => {
                //ErrorResponse(_response)
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_NOTIFICATION_LOADING, false);
                this.context.commit(Mutations.SET_NOTIFICATION_PAGINATION_LOADING, false);
            });
        });
    }
    [_g = Actions.READ_NOTIFICATION](payload) {
        const params = { ver: 'v1' };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.read}?${new URLSearchParams(params).toString()}`, formdata)
                .then((response) => {
                const content = response.data.result.content;
                resolve(content);
            })
                .catch((_response) => {
                swalAlertError('Failed read notification.', 'Close');
                reject(_response);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NotificationModule.prototype, _g, null);
NotificationModule = __decorate([
    Module
], NotificationModule);
export default NotificationModule;
